

import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
import { Info } from 'lucide-react';
import './InviteMembersModal.scss'; // You might want to rename this to SpaceModal.scss
import { useOrgConfig } from '../../../../../hooks/useOrgConfig';

export function InviteMembersModal({ show, onHide, organizationId, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { hasFeature, getLabel } = useOrgConfig();
    
  // Form State
  const [formData, setFormData] = useState({
    name: '',
    type: getLabel('space_unit') || 'unit',
    floor: '',
    metadata: {}
  });

  useEffect(() => {
    if (!show) resetForm();
  }, [show]);

  function resetForm() {
    setFormData({
      name: '',
      type: getLabel('space_unit') || 'unit',
      floor: '',
      metadata: {}
    });
    setLoading(false);
  }

  // Intelligence: Determine if floor is relevant for the type
  const shouldShowFloor = ['unit', 'house', 'office', 'shop', 'ward'].includes(formData.type);

  const spaceTypeOptions = [
    { value: 'unit', label: 'Unit' },
    { value: 'house', label: 'House' },
    { value: 'office', label: 'Office' },
    { value: 'room', label: 'Room' },
    { value: 'shop', label: 'Shop' },
    { value: 'department', label: 'Department' },
    { value: 'ward', label: 'Ward' },
    { value: 'other', label: 'Other' },
  ];

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...formData,
        // organization_id: organizationId,
        // Clear floor if not applicable to the type
        floor: shouldShowFloor ? formData.floor : undefined 
      };

      await dispatch(actions.addData('create_space', payload, organizationId));
      
      if (onSuccess) onSuccess();
      onHide();
    } catch (error) {
      console.error('Error creating space:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      className="create-space-modal"
      backdrop={loading ? "static" : true}
    >
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h5 className="modal-title">Create New {getLabel('spaces')}</h5>
          <button type="button" className="close" onClick={onHide} disabled={loading}>
            <span>&times;</span>
          </button>
        </div>

        <div className="modal-body">
          {/* Space Name */}
          <div className="form-group">
            <label className="form-label">{getLabel('spaces')} Name / Number</label>
            <div className="input-icon-wrapper">
              {/* <Layout size={18} className="input-icon" /> */}
              <input
                required
                className="form-control"
                placeholder="e.g. Apartment 4B or Marketing Dept"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                disabled={loading}
              />
            </div>
          </div>

          {/* Space Type */}
          <div className="form-group">
            {/* <label className="form-label">Type of Space</label> */}
            <select
              className="form-control"
              value={formData.type}
              onChange={(e) => setFormData({...formData, type: e.target.value})}
              disabled={loading}
            >
              {spaceTypeOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* Intelligent Floor Field */}
          {shouldShowFloor && (
            <div className="form-group animate__animated animate__fadeIn">
              <label className="form-label">Floor / Level (Optional)</label>
              <div className="input-icon-wrapper">
                {/* <Layers size={18} className="input-icon" /> */}
                <input
                  className="form-control"
                  placeholder="e.g. Ground, 2nd Floor, Penthouse"
                  value={formData.floor}
                  onChange={(e) => setFormData({...formData, floor: e.target.value})}
                  disabled={loading}
                />
              </div>
            </div>
          )}

          {/* Metadata Hint */}
          <div className="metadata-info">
            <Info size={14} className="mr-2" />
            <small className="text-muted">
              Spaces allow you to group users and visitors by specific locations.
            </small>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-light" 
            onClick={onHide} 
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="btn btn-primary" 
            disabled={loading || !formData.name}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm" />
            ) : (
              'Create '+ getLabel('spaces')
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
}